import { genStyleHooks } from '../../theme/internal';
import type { AliasToken, GenerateStyle } from '../../theme/internal';

export interface S3UploadToken extends AliasToken {
  componentCls: string;
}

export const initS3UploadToken = (token: AliasToken): S3UploadToken => ({
  ...token,
  componentCls: '.youlify-s3-upload',
});

const genS3UploadStyle: GenerateStyle<S3UploadToken> = (token) => {
  const { componentCls } = token;
  return {
    [componentCls]: {
      [`${componentCls}-uploaded-view`]: {
        padding: 16,
        borderRadius: 4,
        border: `1px solid ${token.colorBorder || '#ebecef'}`,
        backgroundColor: token.colorBgContainer || '#fff',
        '&-main': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          height: 'fit-content',
          '&-left': {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            gap: 12,
          },
        },
        '&-icon': {
          display: 'flex',
          padding: 8,
          width: 'fit-content',
          height: 'fit-content',
          border: `1px solid ${token.colorBorderSecondary || '#d4d7dd'}`,
          borderRadius: 4,
        },
        '&-info': {
          '&-name': {
            lineHeight: '22px',
            fontSize: 14,
            fontWeight: 500,
            color: token.colorText || '#141414',
            wordBreak: 'break-all',
          },
          '&-size': {
            lineHeight: '12px',
            fontWeight: 500,
            fontSize: 12,
            color: token.colorTextSecondary || '#6c717c',
          },
        },
        '&-status-bar': {
          display: 'flex',
          alignItems: 'center',
          gap: 24,
        },
        '&-status': {
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          lineHeight: '16px',
          fontSize: 12,
          fontWeight: 500,
        },
        '&-operations': {
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        },
        '&-progress': {
          padding: '14px 0 0 48px',
        },
      },
      [`&${componentCls}-disabled ${componentCls}-uploaded-view`]: {
        backgroundColor: token.colorBgContainerDisabled || '#ebecef',
        border: 'none',
        [`${componentCls}-uploaded-view-icon`]: {
          border: 'none',
          color: token.colorTextSecondary || '#6c717c',
        },
        [`${componentCls}-uploaded-view-info-name`]: {
          color: token.colorTextSecondary || '#6c717c',
        },
      },
      [`${componentCls}-unupload-view`]: {
        padding: 16,
        borderRadius: 4,
        fontSize: 16,
        fontWeight: 500,
        '&-icon': {
          display: 'flex',
          margin: '0 auto',
          padding: 8,
          width: 'fit-content',
          height: 'fit-content',
          border: `1px solid ${token.colorBorderSecondary || '#d4d7dd'}`,
          borderRadius: 4,
        },
        '&-title': {
          marginTop: 12,
          lineHeight: '18px',
          fontSize: 14,
          fontWeight: 500,
          color: '#2D40CB',
        },
        '&-text': {
          marginTop: 16,
          lineHeight: '22px',
          color: token.colorText || '#141414',
          textAlign: 'center',
          '&-underline': {
            textDecoration: 'underline',
          },
        },
        '&-size-text': {
          marginTop: 16,
          lineHeight: '12px',
          fontSize: 10,
          color: token.colorTextSecondary || '#6c717c',
          textAlign: 'center',
        },
      },
    },
  };
};

export const useStyle = genStyleHooks(
  ['Input', 'Component'],
  (token) => [genS3UploadStyle(initS3UploadToken(token))],
  undefined,
  { resetFont: false },
);
